export default "__VITE_ASSET__B2TCyM_7__"